import { Link } from 'react-router-dom';
import '@/styles/help.css';

/** A page's "how does this work?" pointer into the guide for the task it is the start of. */
export function HelpLink({ slug, children = 'How does this work?' }: { slug: string; children?: string }) {
  return <Link to={`/help/${slug}`} className="help-link">{children}</Link>;
}
